import React, { useEffect } from 'react'
import '../../styles/admin/account-box.css'
import { Modal, PasswordInput } from '@mantine/core'
import { useState } from 'react'
import SaveButton from '../../components/common/SaveButton'
import { useAuthStore } from '../../store'
import { apiRequest } from '../../utils/api'
import { notifications } from '@mantine/notifications'
import BaseButton from '../common/BaseButton'
import GuardianInfoModal from '../manager/GuardianInfoModal'
import GuardianEditModal from '../manager/GuardianEditModal'

const AccountBox = () => {
  const [ID, setID] = useState('')
  const [userData, setUserData] = useState({
    LEVEL: '',
    REG_DTM: '',
    NAME: '',
    NICKNAME: '',
    PHONE: '',
    EMAIL: '',
    ROLE: '',
    BIRTH: '',
    PASSWORD: '',
    PARENT_ID: 0,
  })
  const { user } = useAuthStore()
  const [passwordModalOpen, setPasswordModalOpen] = useState(false)
  const [passwordInput, setPasswordInput] = useState('')
  const [guardianModalOpen, setGuardianModalOpen] = useState(false)
  const [guardianEditModalOpen, setGuardianEditModalOpen] = useState(false)
  const [guardianInfo, setGuardianInfo] = useState(null)

  useEffect(() => {
    setID(user?.ID)
  }, [user?.ID])

  useEffect(() => {
    if (ID !== '') {
      fetchUserDetail()
      if(user?.PARENT_ID) fetchUserParentDetail()
    }
  }, [ID])

  const fetchUserParentDetail = async() => {
      try {
        const res = await apiRequest('/fetchUserParentDetail', 'POST', { CHILD_ID : user.ID })
        if (res.success) {
            setGuardianInfo({
               name: res.data.NAME,
               email: res.data.EMAIL,
               phone:  res.data.PHONE,
               id: res.data.PARENT_ID
            })
          } else {
          throw new Error('Failed to search')
        }
      } catch (err) {}
  }


  const fetchUserDetail = async () => {
    try {
      const res = await apiRequest('/fetchUserDetail', 'POST', { ID })
      if (res.success) {
        setUserData((prevData) => ({
          ...prevData,
          ...res.data,
          NAME: res.data.NAME || '',
          NICKNAME: res.data.NICKNAME || '',
          PHONE: res.data.PHONE || '',
          EMAIL: res.data.EMAIL || '',
          BIRTH: res.data.BIRTH || '',
          LEVEL: res.data.LEVEL || '',
          REG_DTM: res.data.REG_DTM || '',
          ROLE: res.data.ROLE || '',
          PASSWORD: res.data.PASSWORD || '',
        }))
      } else {
        throw new Error('Failed to search')
      }
    } catch (err) {}
  }

  const handleLeave = async () => {
    if (!window.confirm(' Are you sure you want to deactive your account?'))
      return

    try {
      const res = await apiRequest('/userDelete', 'POST', { ID })

      if (res.success) {
        useAuthStore.getState().signOut()
        window.location.href = '/signin'
      } else {
        throw new Error('Account deactivation unsuccessful')
      }
    } catch (err) {
      notifications.show({
        title: 'Error',
        message: 'An error occurred while deactivating the account',
        color: 'red',
      })
    }
  }

  const handleSave = () => {
    setPasswordModalOpen(true)
  }

  const verifyAndSave = () => {
    if (passwordInput !== userData.PASSWORD) {
      notifications.show({
        title: 'Error',
        message: 'Passwords do not match',
        color: 'red',
      })
      return
    }

    updateUserInfo()
    setPasswordModalOpen(false)
    notifications.show({
      title: 'Success',
      message: 'Account information saved',
      color: 'green',
    })
  }

  const updateUserInfo = async () => {
    try {
      const res = await apiRequest('/updateUserInfo', 'POST', {
        ID,
        NAME: userData.NAME,
        NICKNAME: userData.NICKNAME,
        PHONE: userData.PHONE,
        EMAIL: userData.EMAIL,
        BIRTH: userData.BIRTH,
      })
      if (!res.success) throw new Error()
    } catch {
      notifications.show({
        title: 'Error',
        message: 'Error occurred while saving',
        color: 'red',
      })
    }
  }

  const handleGuardianAdd = () => {
    setGuardianModalOpen(true)
  }

  const handleGuardianEdit = () => {
    setGuardianEditModalOpen(true)
  }

  const handleGuardianSave = (data) => {
    setGuardianInfo(data)
  }

  return (
    <div className="container">
      <table className="info-table">
        <colgroup>
          <col width="25%" />
          <col width="25%" />
          <col width="25%" />
          <col width="25%" />
        </colgroup>
        <thead></thead>
        <tbody>
          <tr>
            <th>LEVEL</th>
            <td>{userData.LEVEL}</td>
            <th>CREATE</th>
            <td>{userData.REG_DTM}</td>
          </tr>
          <tr>
            <th>NAME</th>
            <td>
              <input
                type="text"
                value={userData.NAME}
                onChange={(e) =>
                  setUserData({ ...userData, NAME: e.target.value })
                }
              />
            </td>
            <th>NICKNAME</th>
            <td>
              <input
                type="text"
                value={userData.NICKNAME}
                onChange={(e) =>
                  setUserData({ ...userData, NICKNAME: e.target.value })
                }
              />
            </td>
          </tr>
          <tr>
            <th>PHONE</th>
            <td>
              <input
                type="text"
                value={userData.PHONE}
                onChange={(e) =>
                  setUserData({ ...userData, PHONE: e.target.value })
                }
              />
            </td>
            <th>EMAIL</th>
            <td>
              <input
                type="text"
                value={userData.EMAIL}
                onChange={(e) =>
                  setUserData({ ...userData, EMAIL: e.target.value })
                }
              />
            </td>
          </tr>
          <tr>
            <th>ROLE</th>
            <td>{userData.ROLE}</td>
            <th>BIRTH</th>
            <td>
              <input
                type="date"
                value={userData.BIRTH}
                onChange={(e) =>
                  setUserData({ ...userData, BIRTH: e.target.value })
                }
              />
            </td>
          </tr>
        </tbody>
      </table>

      {user?.STATUS !== 'M' && user?.STATUS !== 'A' && (
        <div className="guardian-section">
          <h3 className="guardian-title">Guardian Information</h3>

          {guardianInfo ? (
            <div className="guardian-info-box">
              <div className="guardian-details">
                <p>
                  <strong>Name:</strong> {guardianInfo.name}
                </p>
                <p>
                  <strong>Email:</strong> {guardianInfo.email}
                </p>
                <p>
                  <strong>Phone:</strong> {guardianInfo.phone}
                </p>
              </div>
              <div className="save-button-wrapper">
                <SaveButton onClick={handleGuardianEdit}>
                  Edit Guardian
                </SaveButton>
              </div>
            </div>
          ) : (
            <div className="save-button-wrapper">
              <SaveButton onClick={handleGuardianAdd}>Add Guardian</SaveButton>
            </div>
          )}
        </div>
      )}

      <div className="edit-button-wrapper">
        <SaveButton onClick={handleSave} className="account-button">
          Save
        </SaveButton>
        {user?.STATUS !== 'M' && user?.STATUS !== 'A' && (
          <SaveButton onClick={handleLeave} className="account-button">
            Deactivate account
          </SaveButton>
        )}
      </div>

      <Modal
        opened={passwordModalOpen}
        onClose={() => setPasswordModalOpen(false)}
        title="password confirmation"
        centered
      >
        <PasswordInput
          placeholder=" Enter your Password"
          value={passwordInput}
          onChange={(e) => setPasswordInput(e.currentTarget.value)}
        />
        <div
          style={{
            marginTop: '20px',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <BaseButton onClick={verifyAndSave}>Confirm</BaseButton>
        </div>
      </Modal>

      <GuardianInfoModal
        opened={guardianModalOpen}
        onSave={handleGuardianSave}
        onClose={() => setGuardianModalOpen(false)}
        studentInfo={ID}
      />

      <GuardianEditModal
        opened={guardianEditModalOpen}
        onSave={handleGuardianSave}
        onClose={() => setGuardianEditModalOpen(false)}
        guardianData={guardianInfo}
        isEditMode={true}
        parentId={guardianInfo?.id}
      />
    </div>
  )
}

export default AccountBox
